/**
 * Side-effect import that restores reactstrap's intended `PopperContent`
 * transition default.
 *
 * reactstrap 9.2.3 turned `Fade` into a function component and stopped
 * assigning `Fade.defaultProps`, but `PopperContent` still derives its own
 * default from it (`transition: {...Fade.defaultProps}`). That default now
 * resolves to an empty object, so every Tooltip and Popover logs:
 *
 *   Failed prop type: The prop `transition.timeout` is marked as required in
 *   `PopperContent`, but its value is `undefined`.
 *
 * `PopperContent` is a class component, so restoring the default there is safe
 * (no `defaultProps` deprecation warning, unlike patching `Fade`) and the
 * values below are exactly the ones `Fade` still applies internally.
 */
import * as reactstrap from 'reactstrap';

type PopperTransitionDefaults = {
    timeout: number;
    appear: boolean;
    enter: boolean;
    exit: boolean;
    in: boolean;
};

const popperContent = (
    reactstrap as unknown as Record<
        string,
        | {defaultProps?: {transition?: Partial<PopperTransitionDefaults>}}
        | undefined
    >
).PopperContent;

if (popperContent?.defaultProps) {
    popperContent.defaultProps.transition = {
        timeout: 150, // reactstrap's TransitionTimeouts.Fade
        appear: true,
        enter: true,
        exit: true,
        in: true,
        ...popperContent.defaultProps.transition
    };
}
